import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, AUTO_COMPLETE} = FIELD_TYPE;

import React from 'react'

const ModalEditConfig = (optionDV, optionCS, onSelect, onSelectCS) => {
  const dataFields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã xét nghiệm",
      name: "idDichVu",
      disable: true,
    },
    {
      type: AUTO_COMPLETE,
      label: "Tên xét nghiệm",
      name: "tenDichVu",
      rules: [{required: true, message: "Chưa nhập tên xét nghiệm"}],
      options: optionDV,
      onSelect: onSelect
    },
    {
      type: INPUT,
      label: "Mã chỉ số",
      name: "idChiSo",
      disable: true,
    },
    {
      type: AUTO_COMPLETE,
      label: "Chỉ số",
      name: "tenChiSo",
      rules: [{required: true, message: "Chưa nhập chỉ số"}],
      options: optionCS,
      onSelect: onSelectCS
    },
    {
      type: INPUT,
      label: "Mô tả",
      name: "moTa",
      // rules: [{required: true, message: "Chưa nhập tên viết tắt"}],
    },
    {
      type: INPUT,
      label: "Ghi chú",
      name: "ghiChu",
      // rules: [{required: true, message: "Chưa nhập tên viết tắt"}],
    },
  ];
  return (
    dataFields
  )
}

export {ModalEditConfig};
